import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'jobs-index',
  path: () => `/jobs`,
}

export default ROUTE
